import { render, staticRenderFns } from "./Owner.vue?vue&type=template&id=34681e92&scoped=true&"
import script from "./Owner.vue?vue&type=script&lang=js&"
export * from "./Owner.vue?vue&type=script&lang=js&"
import style0 from "./Owner.vue?vue&type=style&index=0&id=34681e92&lang=scss&scoped=true&"
import style1 from "./Owner.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34681e92",
  null
  
)

export default component.exports